/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import { all, call, put, takeEvery, select } from 'redux-saga/effects';
import { actions } from '../../utils/constants';
import history from '../../history';
import routes from '../../utils/routes';

import { saveTemplateQuestions } from '../../utils/common-functions';

function* createQuestion({ payload: { question, options, hasNewQuestion } }) {
    try {
        yield put({
            type: actions.INCREMENT_LOADING_ONLINE_TESTS,
        });

        const newQuestion = {
            title: question,
            enabled: true,
            options: options.map((option, index) => ({
                ...option,
            })),
        };

        yield call(saveTemplateQuestions, newQuestion);
        yield put({
            type: actions.CHANGE_SUCCESS_ADD_QUESTION,
            payload: true,
        });
        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });

        if (!hasNewQuestion) {
            history.push(routes.QUESTIONS_DATABASE);
        }
    } catch (err) {
        yield put({
            type: actions.DECREMENT_LOADING_ONLINE_TESTS,
        });
        yield put({
            type: actions.REQUEST_ERROR,
            payload: {
                message: 'Não foi possível criar uma nova questão',
            },
        });
    }
}

export default function* addQuestion() {
    yield takeEvery(actions.ASYNC_CREATE_QUESTION, createQuestion);
}



// WEBPACK FOOTER //
// ./src/components/add-question/add-question.saga.js